import React from "react"

const Header = ({ titulo, subtitulo, tagline }) => (
  <>
    <div className="barra  bg-grisOscuro">
      <div className="contenedor">
        <nav className="menu-principal">
          <ul id="menu-menu-principal" className="menu">
            <li
              id="menu-item-15"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-7  menu-item-15"
            >
              <a href="https://codigoconjuan.com/" aria-current="page">
                Cursos
              </a>
            </li>
            <li
              id="menu-item-16"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-16"
            >
              <a href="https://codigoconjuan.com/blog/">Blog</a>
            </li>
            <li
              id="menu-item-18"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18"
            >
              <a href="https://codigoconjuan.com/podcast/">Podcast</a>
            </li>
            <li
              id="menu-item-19"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19"
            >
              <a href="https://codigoconjuan.com/workshops/">Workshops</a>
            </li>
            <li
              id="menu-item-19"
              className="menu-item menu-item-type-post_type current_page_item menu-item-object-page menu-item-19"
            >
              <a href="https://codigoconjuan.com/paths/">Paths</a>
            </li>
            <li
              id="menu-item-262"
              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-262"
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://vidafreelancer.com"
              >
                Vida Freelancer
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <header className="site-header">
      <div className="contenido-header py3 header-podcast">
        <div className="contenedor">
          <h1>
            {" "}
            {titulo} <span className="tagline">{subtitulo} </span>
            <em>y llega más lejos...</em>
          </h1>
          <p className="descripcion">{tagline}</p>
        </div>
      </div>
    </header>
  </>
)

export default Header
